// extracted by mini-css-extract-plugin
export var blue = "_2a-g";
export var brand = "_2a-c";
export var darkGrey = "_2a-f";
export var disabled = "_2a-6";
export var disabledSubtle = "_2a-7";
export var error = "_2a-8";
export var green = "_2a-h";
export var grey = "_2a-e";
export var icon = "_2a-0";
export var inherit = "_2a-b";
export var lightGrey = "_2a-d";
export var orange = "_2a-j";
export var pink = "_2a-l";
export var primary = "_2a-1";
export var purple = "_2a-m";
export var quaternary = "_2a-4";
export var quinary = "_2a-5";
export var red = "_2a-k";
export var secondary = "_2a-2";
export var success = "_2a-a";
export var tertiary = "_2a-3";
export var warning = "_2a-9";
export var white = "_2a-n";
export var yellow = "_2a-i";